<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("error") }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-layout row v-if="!hideLine">
                        <v-flex xs12 class="row-v">
                            <div
                                v-for="(item, index) in line"
                                :key="index"
                                class="equipment-item blockHead"
                                :class="{
                                    'selected': index == selectedIndex,
                                    'alert'   : item.alert
                                }"
                                @click="selectEquipment(item, index)"
                            >
                                <v-avatar class="dev-num" size="24" color="primary" text-color="white">{{ index + 1 }}</v-avatar>
                                <v-hover>
                                    <v-card
                                        slot-scope="{ hover }"
                                        class="mx-auto"
                                        color="grey lighten-4"
                                        max-width="600"
                                    >
                                        <v-img
                                            :aspect-ratio="1/1"
                                            :src="item.image"
                                        >
                                            <v-expand-transition>
                                                <div
                                                    v-if="hover"
                                                    class="d-flex transition-fast-in-fast-out blue darken-2 v-card--reveal white--text item-title"
                                                    style="height: 100%;"
                                                >
                                                    {{ $t(item.name) }}
                                                </div>
                                            </v-expand-transition>
                                        </v-img>
                                        <div class="item-title" v-if="false">{{ $t(item.name) }}</div>

                                    </v-card>
                                </v-hover>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row :class="{ 'alert': !hideLine }">
                        <v-flex xs12 :ma-4="!hideLine" :headline="!hideLine">{{ $t(message) }}</v-flex>
                    </v-layout>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="dialog = false">{{ $t("ok") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        name: "CalcErrorDialog",

        data () {
            return {
                dialog:        false,
                title:         "",
                selectedIndex: null,
                hideLine:      true,
                line:          [],
                message:       ""
            }
        },
    }
</script>

<style lang="sass" scoped>
    $brd-radius: 15px

    .equipment-item
        float: left
        width: 150px
        border: solid 1px transparent
        border-radius: $brd-radius
        >
            div
                height: 0
                text-overflow: hidden
                text-align: center
                margin: 2px
                border-radius: $brd-radius
            img
                height: 150px
        &:hover
            >
                div
                    height: auto
                    text-overflow: hidden
                    text-align: center
                    margin: 2px
                    border-radius: $brd-radius
        .item-title
            font-size: 16px
            cursor: pointer

    .equipment-item-small
        float: left
        margin: 5px
        width: 102px
        height: 105px
        border: solid 1px transparent
        text-align: center
        overflow: hidden
        >
            div
                text-align: center
                margin: 2px
            img
                height: 65px
            .item-title
                font-size: 10px
                cursor: default
        &:hover
            box-shadow: 0 1px 2px rgba(0,0,0,0.5)
            transition: ease-in-out .25s

    .row-v
        min-height: 150px
        h3
            overflow: hidden
            text-overflow: ellipsis

    .line
        min-height: 150px
    .line
        :last-child::after
            display: none

    .selected
        background: radial-gradient(#e3f2fd, #bbdefb)

    .blockHead
        border: 0
        background-color: #ddd
        margin: 12px
        height: 150px
        display: inline-block
        position: relative
        &:after
            color: #ddd
            border-left: 20px solid
            border-top: 20px solid transparent
            border-bottom: 20px solid transparent
            display: inline-block
            content: ''
            position: absolute
            right: -20px
            top: 52px
        &.selected:after
            color: #c6e4fc

    .v-card--reveal
        align-items: center
        bottom: 0
        justify-content: center
        opacity: .85
        position: absolute
        width: 100%
        font-size: 12px

    .alert
        background-color: #ff5252
        color: #fff
        border-radius: $brd-radius

    .dev-num
        position: absolute
        z-index: +1
        color: #fff
</style>
